import { defaultSerializer, SRPCError } from "../shared/index.js";
import { createRecursiveProxy } from "../shared/proxy.js";
export * from "../shared/index.js";
export const createSRPCClient = ({ endpoint, headers: getHeaders, transformer = defaultSerializer, fetch = globalThis.fetch })=>{
  return createRecursiveProxy(async ({ path, args })=>{
    const headers = await getHeaders?.({
      path: path
    });
    const response = await fetch(`${endpoint}/${path.join(".")}`, {
      method: "POST",
      body: transformer.serialize(args),
      headers
    });
    const responseText = await response.text();
    const data = transformer.deserialize(responseText);
    if (!response.ok) {
      if ("__BRAND__" in data && data.__BRAND__ === "SRPCError") {
        throw new SRPCError(data.message, data.code);
      }
      throw new SRPCError(response.statusText || "Unknown error", "GENERIC_ERROR");
    }
    return data;
  });
};
//# sourceMappingURL=index.js.map